import type { PIIString } from '@trello/privacy';

export const getDomain = (email: PIIString): PIIString | null => {
  if (!email) {
    return null;
  }
  const lastAt = email.lastIndexOf('@');
  if (lastAt === -1) {
    return null;
  }
  return email.slice(lastAt + 1) || null;
};
